import React from "react";
import { connect } from "react-redux";
import routes from "../../assets/apiRoutes.json";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import ArrayStore from "devextreme/data/array_store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Popup from "devextreme-react/popup";
import LookUpForm from "../../common/lookups/LookUpForm"
import Drawer from 'devextreme-react/drawer';
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";

import DataGrid, {
  Column,
  Editing,
  Lookup,
} from "devextreme-react/data-grid";


import { alert } from "devextreme/ui/dialog";

const orderByData = [
  { ID: 0, Text: "None" },
  { ID: 1, Text: "Ascending" },
  { ID: 2, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
  data: orderByData,
  key: "ID",
});

const prefixData = [
  { ID: 0, Text: "And" },
  { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
  data: prefixData,
  key: "ID",
});

const groupData = [
  { ID: 0, Text: "No" },
  { ID: 1, Text: "Begin" },
  { ID: 2, Text: "End" },
];

const groupDataSource = new ArrayStore({
  data: groupData,
  key: "ID",
});

const operationData = [
  { ID: 0, Text: "StartsWith" },
  { ID: 1, Text: "EndsWith" },
  { ID: 2, Text: "Contains" },
  { ID: 3, Text: "Equal" },
  { ID: 4, Text: "NotEqual" },
  { ID: 5, Text: "Greater" },
  { ID: 6, Text: "GreaterEqual" },
  { ID: 7, Text: "Less" },
  { ID: 8, Text: "LessEqual" },
  { ID: 9, Text: "Between" },
  { ID: 10, Text: "Includes" },
];

const operationDataSource = new ArrayStore({
  data: operationData,
  key: "ID",
});

let accessToken = "";
let ignoreListSelectionChange = false;

// Width of the available-fields list. Used both as the List's own width and as the flex basis of the
// column holding it when embedded, so the two cannot disagree and leave a gap beside it.
const FIELD_LIST_WIDTH_PX = 250;

// Fallback pane height when a host embeds this component without saying how much room it can spare.
// Deliberately modest: too tall clips inside the dialog, too short only wastes space.
const DEFAULT_EMBEDDED_PANE_HEIGHT = '50vh';



class ReportFilter extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    
    this.state = {
          isLookUpFormPopupVisible: false,
          colName: "",
          popupname: "",
          gridrowindex: '',
          connection: null,
          // The field list starts open for ABECAS-type logins on the report screens. When this component is
          // embedded (the Select Items range dialog) the list is the whole point of the screen, so it opens
          // for everyone - otherwise the dialog shows nothing but the collapsed drawer handle.
          opened: props.embedded === true
            || (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
        };

    this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
    this.dataFieldRender = this.dataFieldRender.bind(this);
    this.editorPreparing = this.editorPreparing.bind(this);
    this.searchPopupCellRender = this.searchPopupCellRender.bind(this);
    this.openSearchPopup = this.openSearchPopup.bind(this);
    this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);
    this.handleCallbackforReportLookUp = this.handleCallbackforReportLookUp.bind(this);
    this.CellClik = this.CellClik.bind(this);
    this.cellPrepared = this.cellPrepared.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.dataFieldItemClick = this.dataFieldItemClick.bind(this);
  }

  handleCallbackforReportLookUp(data) {
    if (this.state.gridrowindex && (this.state.colName == "to" || this.state.colName == "from"))
    {
      this.props.gridRefs[this.props.rowIndex].instance().cellValue(this.state.gridrowindex, this.state.colName, data);
    }

    this.setState({
      gridrowindex: '',
      isLookUpFormPopupVisible: false
    });
  };

  gridRef = (el) => {
    if (el) {
      if(this.props.gridRefs)
      {
        this.props.gridRefs[this.props.rowIndex] = el;
      }
    }
  };

  openSearchPopup(e) {
    let rowIndex = e.element.attributes['data-rowindex'].value;
    let lkupnm = e.element.attributes['data-lookupName'].value;
    this.setState({
      isLookUpFormPopupVisible: true,
      popupname: lkupnm,
      gridrowindex: rowIndex
    });
  };
  handleClosePopUpCallback() {
    this.setState({
      isLookUpFormPopupVisible: false,
    });
  };
  searchPopupCellRender(rowobj) {

    if (rowobj && rowobj.data && rowobj.data.popupName &&
      ((rowobj.data.popupName.toLowerCase() == "wmitem") || (rowobj.data.popupName.toLowerCase() == "wmlot") ||
        (rowobj.data.popupName.toLowerCase() == "wmsublot") || (rowobj.data.popupName.toLowerCase() == "location"))) {

      let lkupnm = (rowobj.data.popupName.toLowerCase() == "wmitem") ? "Item" : (rowobj.data.popupName.toLowerCase() == "wmlot") ? "Lot" :
        (rowobj.data.popupName.toLowerCase() == "wmsublot") ? "SubLot" : (rowobj.data.popupName.toLowerCase() == "location") ? "Location" : "";

      let buttonAttributes = { 'data-rowIndex': rowobj.rowIndex.toString(), 'data-lookupName': lkupnm }
      return <Button icon="find" onClick={this.openSearchPopup} elementAttr={buttonAttributes} />;

    }
    else
      return "";

  };
  CellClik(e) {
    if (e.column && e.column && e.column.caption && (e.column.caption.toLowerCase() == 'to' || e.column.caption.toLowerCase() == 'from')) {
      this.setState({
        colName: e.column.caption.toLowerCase(),
      });
    }
  };

  /** Available fields. Clicking one adds it to the criteria grid. */
  renderFieldList(height, className) {
    return (
      <List
        dataSource={{
            store: new ArrayStore({
              data: this.props.whereInfoList,
              key: "displayLabel"
            }),
            paginate: false,
        }}
        // pageLoadMode="scrollBottom"
        style={{ backgroundColor: '#F6F7FB' }}
        displayExpr="displayLabel"
        searchEnabled={true}
        searchExpr="displayLabel"
        /*
        showSelectionControls={true}
        selectionMode="multiple"
        onSelectionChanged={this.dataFieldSelectionChanged}
        onItemRendered={this.dataFieldRender} */
        onItemClick={this.dataFieldItemClick}
       // height={this.props.selectedItems.length > 0 ? (this.props.formItems.length > 0 ? ReportFilterPanelHeightAccordionOpen : "calc(100vh - 370px)") : "calc(100vh - 255px)"}
        className={className}
        height={height}
        width={FIELD_LIST_WIDTH_PX}
      ></List>
    );
  }

  render() {
    // Embedded in a dialog: the fields list is pinned next to the criteria grid instead of living behind the
    // drawer handle, which is both what the legacy Record Range dialog looks like and one less thing that can
    // render at zero size.
    const embedded = this.props.embedded === true;

    // Panes need a definite height. The report pages get it from the calc(100vh - …) classes below; in a
    // dialog the host passes the height it can spare, because a percentage chain does not resolve through
    // TabPanel's multiview content.
    const paneHeight = embedded ? (this.props.paneHeight || DEFAULT_EMBEDDED_PANE_HEIGHT) : undefined;

    const listClassName = embedded
      ? undefined
      : (this.props.selectedItems.length > 0 ? "ReportFilterPanelHeightAccordionOpen" : "ReportFilterPanelHeightAccordionClose");

    const gridClassName = embedded
      ? undefined
      : (this.props.selectedItems.length>0?(this.props.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed");

    const filterGrid = this.renderFilterGrid(paneHeight, gridClassName);

    return (
      <div>
        {!embedded &&
          <div className="row">
            <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
              <Toolbar >
                <Item location="before">
                <Button icon= 'menu' className="gridTopButton" onClick={() => this.setState({ opened: !this.state.opened })}  />
                </Item>
              </Toolbar>
            </div>
          </div>
        }
        {embedded ? (
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ flex: `0 0 ${FIELD_LIST_WIDTH_PX}px` }}>{this.renderFieldList(paneHeight, listClassName)}</div>
            <div style={{ flex: '1 1 auto', minWidth: 0 }}>{filterGrid}</div>
          </div>
        ) : (
        <div className="row">
          <div>
            <Drawer
              opened={this.state.opened}
              openedStateMode={'shrink'}
              position={'left'}
              revealMode={'slide'}
              render={() => this.renderFieldList(undefined, listClassName)}
              closeOnOutsideClick={false}
              >
                {filterGrid}
            </Drawer>
          </div>
        </div>
        )}
        {this.renderLookUpPopup()}
      </div>
    );
  }

  /** The criteria grid: one row per field the user chose, with its operation and From/To values. */
  renderFilterGrid(height, className) {
    return (
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                  id={"gridContainer" + this.props.rowIndex}
                  ref={this.gridRef}
                  showBorders={true}
                  height={height}
                  className={className}
                  rowAlternationEnabled={true}
                  allowColumnReordering={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onEditorPreparing={this.editorPreparing}
                  onCellClick={this.CellClik}
                  onRowUpdated={(e) => this.props.onRowUpdated && this.props.onRowUpdated(e, this.props.rowIndex)}
                  onRowInserted={(e) => this.props.onRowInserted && this.props.onRowInserted(e, this.props.rowIndex)}
                  onRowRemoved={(e) => this.props.onRowRemoved && this.props.onRowRemoved(e, this.props.rowIndex)}
                >
                  <Editing
                    mode="cell"
                    newRowPosition="last"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                    confirmDelete={false}
                  />
                  {/* <Column type="buttons">
                    <Button name="delete" />
                  </Column> */}
                  <Column
                    dataField="displayLabel"
                    caption="Display Label"
                    allowEditing={false}
                  />
                  <Column dataField="orderBy" caption="Order By">
                    <Lookup
                      dataSource={orderByDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="prefix" caption="Prefix">
                    <Lookup
                      dataSource={prefixDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="group" caption="Group">
                    <Lookup
                      dataSource={groupDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="operation" caption="Operation">
                    <Lookup
                      dataSource={operationDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="from" caption="From" />
                  <Column dataField="to" caption="To" />
                  <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                </DataGrid>
    );
  }

  /** Lookup form for a From/To cell that has one (Item, Lot, SubLot, Location). */
  renderLookUpPopup() {
    if (!this.state.isLookUpFormPopupVisible) {
      return null;
    }

    return (
      <Popup
        visible={this.state.isLookUpFormPopupVisible}
        onHiding={this.handleClosePopUpCallback}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title={this.state.popupname + " Look Up Form"}
        className="custom-popup"
        container=".dx-viewport"
        closeOnOutsideClick={true}
      >
          <LookUpForm lookupname={this.state.popupname} parentCallbackLookUp={this.handleCallbackforReportLookUp}
          ></LookUpForm>
      </Popup>
    );
  }



  cellPrepared(e) {
    if (e.rowType === "data" && e.row.data.fieldType == 4) {
      if (this.isValidDate(e.row.data.from)) {
        let dt = new Date(e.row.data.from);
        e.row.data.from = (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
      }
      if (this.isValidDate(e.row.data.to)) {
        let dt = new Date(e.row.data.to);
        e.row.data.to = (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
      }
    }
  }
  isValidDate(date) {
    return date && !isNaN(Date.parse(date));
  }
  editorPreparing(e) {
    if (e.parentType === "dataRow" && e.hasOwnProperty('row') && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorName') &&
      (e.dataField === "from" || e.dataField === "to") && e.editorName == "dxTextBox") {
      if (e.row.data.lookupName == null || e.row.data.lookupName == "") {
        switch (e.row.data.fieldType) {
          case 1: // Integer
          case 2: // Decimal
            e.editorName = "dxNumberBox";
            break;
          case 3: // Boolean
            e.editorName = "dxCheckBox";
            break;
          case 4: // DateTime
            e.editorName = "dxDateBox";
            // const defaultValueChangeHandler = e.editorOptions.onValueChanged;
            var that = this;
            e.editorOptions.onValueChanged = function (args) {  // Override the default handler
              if (that.isValidDate(args.value)) {
                let dt = new Date(args.value);
                e.setValue((dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear());
                // e.setValue(((dt.getMonth() > 8) ? (dt.getMonth() + 1) : ('0' + (dt.getMonth() + 1))) + '/' + ((dt.getDate() > 9) ? dt.getDate() : ('0' + dt.getDate())) + '/' + dt.getFullYear());
              }
              else {
                e.setValue(args.value);
              }

              // If you want to modify the editor value, call the setValue function:
              // e.setValue(newValue);
              // Otherwise, call the default handler:
              //  defaultValueChangeHandler(args);
            }
            break;
          case 5: // Flag
            e.editorName = "dxSelectBox";
            e.editorOptions.items = [];

            for (var i = 0; i < e.row.data.items.length; i++) {
              var selectBoxItem = new Object();
              selectBoxItem.Value = e.row.data.items[i].text;
              selectBoxItem.Text = e.row.data.items[i].text;
              e.editorOptions.items.push(selectBoxItem);
            }

            e.editorOptions.displayExpr = "Text";
            e.editorOptions.valueExpr = "Text";
            e.editorOptions.showClearButton = true;
            break;
        }
      }
      else {
        e.editorName = "dxSelectBox";
        var selectstore = createStore({
          loadUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.GetLookupData}`,
          loadParams: { lookupName: e.row.data.lookupName },
          onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            };
          }

        });
        e.editorOptions.dataSource = selectstore;
        e.editorOptions.searchEnabled = true;
        e.editorOptions.showClearButton = true;
        e.editorOptions.acceptCustomValue = true;
        // e.editorOptions.defaultValue = e.row.data.from;
      }
    }

    if (e.dataField === 'operation' && e.parentType === 'dataRow') {
      const defaultValueChangeHandler = e.editorOptions.onValueChanged;
      e.editorOptions.onValueChanged = function (args) { // Override the default handler
        defaultValueChangeHandler(args);
        if (args.value != 9) {
          e.component.cellValue(e.row.rowIndex, "to", "");
        }

      }
    }

    if (e.dataField === "to" && e.parentType === "dataRow") {
      e.editorOptions.disabled = e.row.data && e.row.data.operation !== 9;
    }
  }

  dataFieldSelectionChanged(e) {
    if (!ignoreListSelectionChange) {
      if (e.addedItems != null && e.addedItems.length === 1) {
        var dataSource = this.props.gridRefs[this.props.rowIndex].instance().getDataSource();
        dataSource
          .store()
          .insert(e.addedItems[0])
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }

      if (e.removedItems != null && e.removedItems.length === 1) {
        var dataSource = this.props.gridRefs[this.props.rowIndex].instance().getDataSource();
        dataSource
          .store()
          .remove(e.removedItems[0].displayLabel)
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }
    }
  }

  dataFieldRender(e) {
    var dataSource = this.props.gridRefs[this.props.rowIndex].instance().getDataSource();
    if (dataSource != null && dataSource._items != null) {
      var found = dataSource._items.find(i => i.origin == e.itemData.origin);
      if (found != null && found != undefined) {
        if (!e.component.isItemSelected(e.itemIndex)) {
          ignoreListSelectionChange = true;
          e.component.selectItem(e.itemIndex);
          ignoreListSelectionChange = false;
        }
      }
    }
  }

  dataFieldItemClick(e) {
    var dataSource = this.props.gridRefs[this.props.rowIndex].instance().getDataSource();
    if(dataSource)
    {
      dataSource
        .store()
        .insert(e.itemData)
        .done(function (dataObj, key) {
          dataSource.reload();
        })
        .fail(function (error) {
          alert(error);
        });
    }
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ReportFilter);
